const DefaultCell = ({ value }) => value || null;

export default function FlexTableCell({ row, value, flex = "none", Cell = DefaultCell }) {
	return (
		<div style={{ flex }}>
			<Cell row={row} value={value} />
		</div>
	);
}
